import { makeStyles } from "@material-ui/core";

export const useLoadingStyles = makeStyles(() => ({
    root: {
        margin: "100px 0px"
    }
}));
